const initialClass = {
  id: null,
  name: "",
  users: [],
};

export default initialClass;
